import { environment as env } from '../../../../../environments/environment';

const BASE_API_URL = env.ApiUrl + 'api/'; // env.apiGateWayAdmin;
// const ADMIN_BASE_API_URL = env.ApiUrl; // env.apiGateWayAdmin;

export const PERIOD_CONTACTABILITY_ENDPOINTS = {
  base: BASE_API_URL,
  list: BASE_API_URL + 'period-contactability',
  item: BASE_API_URL + 'period-contactability/{id}',
  status: BASE_API_URL + 'period-contactability/status/{status}'

};



